import { render, staticRenderFns } from "./TaskCm.vue?vue&type=template&id=52f9d74a&scoped=true"
import script from "./TaskCm.vue?vue&type=script&lang=ts"
export * from "./TaskCm.vue?vue&type=script&lang=ts"
import style0 from "./TaskCm.vue?vue&type=style&index=0&id=52f9d74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9d74a",
  null
  
)

export default component.exports